<div
  *ngIf="country$ | async as selectedCountry"
  class="d-flex align-items-center dropdown country-dropdown"
  bsDropdown
  placement="bottom left"
>
  <div class="d-flex align-items-center clickable dropdown-toggle" dropdownToggle>
    <div class="img-box">
      <img [src]="'/assets/images/firms/' + selectedCountry.toLowerCase() + '.png'" />
    </div>
  </div>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right note mt-2" role="menu">
    <li class="semibold px-4 py-2">Member Firms</li>
    <li
      class="d-flex align-items-center px-4 py-1 dropdown-item clickable"
      *ngFor="let memberFirm of memberFirms$ | async"
      [ngClass]="{ active: selectedCountry === memberFirm.countryCode?.toLowerCase() }"
      (click)="handleSelectCountry(memberFirm)"
    >
      <div class="img-box">
        <img [src]="'/assets/images/firms/' + memberFirm.countryCode?.toLowerCase() + '.png'" />
      </div>
      <div class="px-3 text-ellipsis">
        {{ memberFirm.name }}
      </div>
    </li>
  </ul>
</div>
